import { useTranslation } from "react-i18next";
import Button from './Button';
import { Component } from "react";
import { fetch } from "../utils/fetch";

const ErrorPage = ({ error, errorInfo }) => {
    const { t } = useTranslation();

    return <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
        <img className="my-3" src={process.env.PUBLIC_URL + '/error_cartoon.png'} alt={t('errorMessge')} width={256} height={256}></img>
        <h3>{t('errorMessage')}</h3>
        <p className="my-3">{t('errorDetails')}</p>
        <Button variant="primary" onClick={() => window.location.reload()}>{t('refreshPage')}</Button>
        <p style={{ textAlign: 'start', fontSize: 'small', fontFamily: 'monospace'}}>
            Backtrace:<br/>
            <pre>{error?.stack}</pre><br/>
            Component Trace: <br/>
            <pre>{errorInfo?.componentStack}</pre>
        </p>    
    </div>
}

class TopErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({ error, errorInfo })
        fetch('/client-errors', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                errorUrl: window.location.href,
                errorMessage: error?.message,
                componentStack: errorInfo?.componentStack,
                timestamp: (new Date()).toISOString(),
                stackTrace:  error?.stack,
                cause: error?.cause || ""
            })
        });
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return <ErrorPage error={this.state.error} errorInfo={this.state.errorInfo} />;
        }

        return this.props.children;
    }
}

export default TopErrorBoundary;